<template>
  <el-card id="more">
    <div class="main clearfloat marginT20">
      <div class="templateBox left">
        <img
          class="phoneImg"
          :src="require('@/assets/imges/standard/airCleaner/airMore.png')"
          alt
        />
      </div>
      <!-- 箭头块 -->
      <div class="iconBox left">
        <i class="el-icon-right iconRight" style="margin-top: 66px"></i>
        <i class="el-icon-right iconRight" style="margin-top: 270px"></i>
      </div>
      <!-- 配置块 -->
      <div class="configBox left">
        <div v-for="(group, i) in groups" :key="i" class="btn-group">
          <p class="marginB10 marginT20" style="color: red;">
            {{ "按钮组" + (i + 1) }}
          </p>
          <el-input
            size="small"
            class="btnConfigInput left"
            style="margin-right:10px;"
            placeholder="功能名称"
            v-model="group.name"
          />
          <el-input
            size="small"
            class="btnConfigInput left"
            placeholder="功能描述"
            v-model="group.description"
          />
          <div class="btn-group-operation">
            <el-button :disabled='i == 0' size="mini" plain type="primary" @click="move(i, 'up')"
              >上移</el-button
            >
            <el-button :disabled='groups.length - 1 == i' size="mini" plain type="primary" @click="move(i, 'down')"
              >下移</el-button
            >
            <el-button size="mini" plain type="danger" @click="deleteGroup(i)"
              >删除</el-button
            >
          </div>
          <div class="btnConfigList">
            <div
              class="btnConfigItem marginT10"
              v-for="(item, index) in group.moreList"
              :key="index"
            >
              <!-- 操作 -->
              <div class="btnConfigHeader clearfloat">
                <span class="marginR10">{{ "按钮" + (index + 1) }}</span>
                <img :src="item.image" v-if="item.image" class="btnImage" />
                <el-button
                  size="mini"
                  class="right moveBtn"
                  type="danger"
                  :disabled="item.btnType != 4"
                  icon="el-icon-delete"
                  @click="handleDelete(i, index)"
                ></el-button>
                <el-button
                  size="mini"
                  class="right marginR10 moveBtn"
                  type="primary"
                  :disabled="index == 0"
                  icon="el-icon-top"
                  @click="handleMove('up', i, index)"
                ></el-button>
                <el-button
                  size="mini"
                  class="right moveBtn"
                  type="primary"
                  :disabled="index == group.moreList.length - 1"
                  icon="el-icon-bottom"
                  @click="handleMove('down', i, index)"
                ></el-button>
              </div>
              <!-- 配置 -->
              <div class="btnConfigBody marginT10 clearfloat">
                <!-- 名称 -->
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="功能名称"
                  placement="top-start"
                >
                  <el-input
                    size="small"
                    class="btnConfigInput left"
                    v-model="item.name"
                    :disabled="item.btnType != 4"
                  ></el-input>
                </el-tooltip>
                <!-- 类型 -->
                <el-select
                  v-if="item.btnType == 4"
                  v-model="item.type"
                  size="small"
                  class="btnConfigInput left marginL10"
                >
                  <el-option
                    v-for="type in btnTypes"
                    :key="type.value"
                    :value="type.value"
                    :label="type.label"
                  ></el-option>
                </el-select>
                <!-- 页面 type == 2 -->
                <el-select
                  v-model="item.secondImageId"
                  v-if="item.type == 2"
                  size="small"
                  class="btnConfigInput left marginL10"
                  @change="
                    val => {
                      handleChangePageType(i, index, val);
                    }
                  "
                >
                  <el-option
                    v-for="page in pages"
                    :key="page.id"
                    :value="page.id"
                    :label="handlePageName(page)"
                  ></el-option>
                </el-select>
                <!-- 属性 type == 1 -->
                <el-select
                  v-model="item.propertyId"
                  v-if="item.type == 1"
                  size="small"
                  class="btnConfigInput left marginL10"
                >
                  <el-option
                    v-for="type in propertes"
                    :key="type.id"
                    :value="type.id"
                    :label="type.propertyName"
                  ></el-option>
                </el-select>
                <!-- 外链 type == 3 -->
                <el-input
                  size="small"
                  class="longInput left marginL10"
                  v-model="item.linkUrl"
                  v-if="item.type == 3"
                ></el-input>
              </div>
            </div>
          </div>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            class="marginT10"
            @click="handleAddBtn(i)"
          ></el-button>
        </div>
        <el-button size="small" plain type="primary" @click="addGroup"
          >新增按钮组</el-button
        >
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  props: {
    productId: {
      type: String,
      default: () => {
        return "";
      }
    },
    moreData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    pages: {
      type: Array,
      default: () => {
        return [];
      }
    },
    propertes: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  watch: {
    moreData: {
      deep: true,
      handler(val) {
        if (val && val.airMore && val.airMore.length > 0) {
          this.groups = Object.assign([], val.airMore);
        }
      }
    }
  },
  data() {
    return {
      groups: [
        {
          name: "",
          description: "",
          moreList: [
            {
              name: "设备信息",
              btnType: 3
            },
            {
              name: "设备共享",
              btnType: 2
            },
            {
              name: "设备名称",
              btnType: 1
            }
          ]
        },
        {
          name: "",
          description: "",
          moreList: [
            {
              name: "售后热线",
              btnType: 6
            }
          ]
        }
      ],
      btnList: [
        {
          name: "设备名称",
          btnType: 1
        },
        {
          name: "设备共享",
          btnType: 2
        },
        {
          name: "设备信息",
          btnType: 3
        },
        {
          name: "重置WIFI",
          btnType: 5
        },
        {
          name: "",
          type: "",
          desc: "",
          propertyId: "", // 属性ID
          secondImageId: "", // 页面Id
          pageType: "", // 页面类型
          linkUrl: "", // 外链
          btnType: 4
        }
      ],
      btnTypes: [
        {
          value: 1,
          label: "属性"
        },
        {
          value: 2,
          label: "页面"
        },
        {
          value: 3,
          label: "外链"
        }
      ]
    };
  },
  methods: {
    // 修改按钮指向页面时
    handleChangePageType: function(i, index, val) {
      for (let key in this.pages) {
        if (this.pages[key].id == val) {
          this.groups[i].moreList[index].pageType = this.pages[key].type;
        }
      }
    },
    // 提交表单
    handleSubmit: function() {
      return this.groups;
    },
    handleDelete: function(i, index) {
      this.groups[i].moreList.splice(index, 1);
    },
    // 新增
    handleAddBtn: function(i) {
      this.groups[i].moreList.push({
        name: "",
        type: "",
        propertyId: "", // 属性ID
        secondImageId: "", // 页面Id
        desc: "", // 辅助描述
        pageType: "", // 页面类型
        linkUrl: "", // 外链
        btnType: 4
      });
    },
    // 移动按钮
    handleMove: function(fun, i, idx) {
      let list = this.$utils.handleMoveArr(this.groups[i].moreList, fun, idx);
      this.$set(this.groups[i], "moreList", list);
    },
    move(i, type) {
      let list = this.$utils.handleMoveArr(this.groups, type, i);
      this.$set(this, "groups", list);
    },
    deleteGroup(i) {
      this.groups.splice(i, 1);
    },
    addGroup() {
      this.groups.push({
        name: "",
        description: "",
        moreList: []
      });
    },
    handlePageName: function(page) {
      let type = this.$utils.escapePageName(page.type),
        nvgName = page.nvgName;
      if (page.inner) {
        return type;
      } else {
        return nvgName + "-" + type;
      }
    }
  }
};
</script>

<style scoped lang="less">
.btn-group {
  position: relative;
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 16px;
  margin-bottom: 16px;
  .btn-group-operation {
    position: absolute;
    top: 16px;
    right: 16px;
  }
}
.templateBox {
  width: 280px;
}
.iconRight {
  display: block;
  font-size: 28px;
}

.title {
  font-weight: 500;
  font-size: 14px;
}
.phoneImg {
  width: 280px;
  height: 500px;
}
.configBox {
  border: 1px solid #ccc;
  width: calc(100% - 350px);
  border-radius: 5px;
  padding: 20px;
  min-height: 478px;
}
.btnConfigList {
  margin-top: 50px;
}
.btnConfigHeader {
  max-height: 40px;
  vertical-align: bottom;
  font-size: 14px;
}
.btnConfigUpload {
  display: inline-block;
  vertical-align: bottom;
}
.btnConfigInput {
  width: 150px;
}
.btnConfigLong {
  width: calc(100% - 320px);
}
.btnImage {
  margin-left: 10px;
  vertical-align: bottom;
  width: 28px;
  height: 28px;
}
.longInput {
  width: 250px;
}
</style>
